import { useEffect, useState } from "react";
import { Table, Space } from "antd";
import axios from "axios";
import { api } from "../../../api/url";

// --------------- modals
import VisitDetailModal from "../../../components/Modals/VisitDetail";
import CancelVisitModal from "../../../components/Modals/Cancel";

// --------------- style
import "./style.css";
import { number_3_3 } from "../../../utilities";


const UserHistory = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [curId, changeCurId] = useState();
  const [curItem, changeCurItem] = useState();
  const [step, setStep] = useState(0);
  // const today = new Date().toLocaleDateString("IR");

  // ------------------- get History
  const GetHistory = async () => {
    await axios({
      method: "post",
      url: api + "appointment/user/getappointments/",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      data: {
        pageNo: page * 10,
        pageRowsCount: 100,
        appointmentUserId: localStorage.getItem("user"),
      },
    })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    GetHistory();
  }, []);

  // ----------------------------- show detail
  const showDetail = (item) => {
    changeCurId(item.admissionId);
    setShowDetailsModal(true);
  };

  const cancelshowDetail = () => {
    setShowDetailsModal(false);
    changeCurId();
  };

  // ----------------------------- show cancel
  const showCancel = (item) => {
    changeCurItem(item);
    setShowCancelModal(true);
    setStep(0);
  };

  const cancelshowModal = () => {
    setShowCancelModal(false);
    changeCurItem();
    setStep(0);
  };

  const columns = [
    {
      title: "نام پزشک",
      dataIndex: "attenderFullName",
      key: "name",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "نام مرکز",
      dataIndex: "companyName",
      key: "departmentname",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "تاریخ و ساعت",
      dataIndex: "reserveDatePersian",
      key: "age",
      render: (_, record) => (
        <Space size="middle">
          <a>{record.reserveDatePersian}</a>
          <span>-</span>
          <a>{record.reserveTime}</a>
        </Space>
      ),
    },
    {
      title: "مبلغ",
      dataIndex: "cashAmount",
      key: "address",
      render: (_, record) => (
        <Space size="middle">
          <a>{number_3_3(record.cashAmount)}</a>
          <a>ریال</a>
        </Space>
      ),
    },
    {
      title: "عملیات",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <a onClick={() => showDetail(record)} className="userhistory-detailt">
            جزيیات
          </a>

          {new Date(record.reserveDate).getTime() > new Date().getTime() && (
            <a
              onClick={() => showCancel(record)}
              className="userhistory-cancel"
            >
              لغو نوبت
            </a>
          )}
        </Space>
      ),
    },
  ];

  return (
    <>
      <Table
        // pagination={{
        //   // total: totalPassengers,
        //   onChange: (page, pageSize) => {
        //     fetchRecords(page, pageSize);
        //   },
        // }}
        style={{
          paddingBottom:100
        }}
        pagination={{
          pageSize: 10,
        }}
        loading={loading}
        rootClassName="userhistory-table"
        columns={columns}
        dataSource={data}
      />

      {curId && (
        <VisitDetailModal
          curId={curId}
          open={showDetailsModal}
          setOpen={setShowDetailsModal}
          setClose={cancelshowDetail}
        />
      )}

      {showCancelModal && (
        <CancelVisitModal
          curItem={curItem}
          open={showCancelModal}
          setOpen={setShowCancelModal}
          setClose={cancelshowModal}
          step={step}
          setStep={setStep}
        />
      )}
    </>
  );
};

export default UserHistory;
